import 'babel-polyfill'
import es6Promise from 'es6-promise'
es6Promise.polyfill()

import 'classlist-polyfill'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from '@/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/global.css' /*引入公共样式*/
import '@/styles/font.scss';
import i18n from './lang' // Internationalization
import { setInfo, getInfo } from '@/utils/auth'
Vue.use(setInfo, getInfo)
// import './assets/iconfont/iconfont.css' //全局引入阿里字体图标




import Print from 'vue-print-nb'
import echarts from 'echarts'
import { MessageBox } from 'element-ui'
import 'video.js/dist/video-js.css'
import nodata from './components/noData/index.js'
import dataV from '@jiaminghi/data-view'

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);


Vue.use(nodata);
Vue.use(Print);
Vue.use(dataV);

import '@/plugins/element-ui'



Vue.use(ElementUI, {
    size: setInfo('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});
// Vue.use(MessageBox)


Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

if (!window.es6Promise) {
    window.es6Promise = es6Promise;
}



router.beforeEach((to, from, next) => {
    localStorage.setItem('fullPath', from.matched[0].path)
    if (to.meta.requireAuth) { //判断该路由是否需要登录权限   我将首页七个模块设置true，其他二级页面不设置，所以没登录时只能跳七个模块的首界面
        next()
    } else {
        if (getInfo('tokens')) { // 如果登录，就能跳二级页面，没有就提示
            next()
        } else {

            // ElementUI.Message('请先进行登录')
            // window.clikLogin()
            next()
        }
    }
})